import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme"];
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */

import { SearchInputSkeleton, ThemeProvider } from '@atlassian/search-dialog/skeleton';
import React from 'react';
export var ProductSearchInputSkeleton = function ProductSearchInputSkeleton(_ref) {
  var theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (theme) {
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      partialSearchCSS: theme
    }, /*#__PURE__*/React.createElement(SearchInputSkeleton, rest));
  } else {
    return /*#__PURE__*/React.createElement(SearchInputSkeleton, rest);
  }
};